<template>
	<div class="header-container width-100 display-flex flex-row flex-align-center flex-justify-space-between">
		<AnemicButton v-if="hasEditPermissions" @click="$emit('edit-structure')" class="icon-and-text-button flex-centerize">
			<SIcon name="edit-interface-structure" class="button-icon mr-1" />
			Edit interface structure
		</AnemicButton>
		<AnemicButton v-if="!noPreview" @click="$emit('show-preview')" class="icon-and-text-button flex-centerize">
			<SIcon class="button-icon mr-1" name="modal-preview" :width="14" />
			Preview
		</AnemicButton>
	</div>
</template>

<script>
export default {
	name: 'WidgetEditHeader',
	props: {
		noPreview: { type: Boolean },
		hasEditPermissions: { type: Boolean },
	},
};
</script>

<style lang="scss" scoped>
.header-container {
	height: 66px;
	padding: 0px 24px;
	background: var(--primary-bg-color);
	border: 1px solid var(--border-color);
	border-top: 0px;
}

.icon-and-text-button {
	font-size: 12px !important;
	color: var(--primary-font-color) !important;

	padding: 10px 8px !important;
	border-radius: 8px !important;
	background: var(--bg-color) !important;
	border: 1px solid var(--button-border) !important;

	.button-icon {
		margin-top: 2px;
	}
}
</style>
